// extracted by mini-css-extract-plugin
export var button = "transition-team-member-card-module--button--af4fa";
export var container = "transition-team-member-card-module--container--ee706";
export var description = "transition-team-member-card-module--description--9f03c";
export var name = "transition-team-member-card-module--name--23dcb";
export var role = "transition-team-member-card-module--role--a9166";